import React from 'react';
import styles from './index.module.scss';
import clsx from 'clsx';
import ButtonWithArrowIcon from 'components/Buttons/ButtonWithArrowIcon';

type StepEndProps = {
  className?: string;
  logo?: string;
  onNext: () => void;
};

const StepEnd: React.FC<StepEndProps> = (props) => {
  return (
    <div className={clsx(styles.root, props.className)}>
      <h2>Submitted!</h2>
      <p>
        Thanks for submitting the driver checklist. Please return to the portal
        to upload any other necessary documents.
      </p>
      <ButtonWithArrowIcon
        onClick={props.onNext}
        variant="contained"
        color="primary"
      >
        Next
      </ButtonWithArrowIcon>
    </div>
  );
};

export default StepEnd;
